export const convertASCIIToChar = (value: number) => String.fromCharCode(value);
